<template>
    <ModalFormCard class="modal-default" :action='"/admin/actions/company/" + company.id + "/one-off-payment"'>
        <template #title>Take payment from {{ company.name }}</template>

        <template #default="{ saving, errors }">
            <p class='text-15 font-semibold'>Take one off payment</p>
            <p class='text-14 text-grey-900 mt-2'>
                You can use this to take a one time payment from the customer
            </p>

            <Select class='mt-4' name='reason'
                v-model:value='value.reason'
                placeholder='Reason'
                label='Reason for payment' 
                :options="[
                    { value: 'Rebrand' },
                    { value: 'Other' },
                ]" 
            />

            <Textarea name='reason_other' v-model:value='value.reason_other' 
                label='Other reason' v-if='value.reason == "Other"' 
                class='mt-4'
            /> 

            <div class='grid grid-cols-2 mt-4 gap-4'>
                <Input name='amount' v-model:value='value.amount' label='Amount to take' />

                <InputCheckbox class='mt-10' :checked='value.include_vat' 
                    @change='value.include_vat = !value.include_vat' value="1">
                    <p class="text-14 text-grey-900 pl-2">Include VAT</p>
                </InputCheckbox>
            </div>

            <SelectCard 
                v-model:value="value.card_id"
                :disabled="saving"
                :options="cards"
                valueKey="id"
                class="mt-4"
                :hideAddNewCard='true'
            />

            <p class='text-15 font-semibold mt-6'>Payment breakdown</p>

            <div class='text-15 flex items-center justify-between py-4'>
                <p>Sub total</p>
                <p>{{ $help.dp(total / 1.2) }}</p>
            </div>
            <div class='text-15 flex items-center justify-between border-y border-grey-500 py-4'>
                <p>VAT</p>
                <p>{{ $help.dp(total - (total / 1.2)) }}</p>
            </div>
            <div class='text-15 flex items-center justify-between py-4'>
                <p>Total</p>
                <p>{{ $help.dp(total) }}</p>
            </div>

            <InputCheckbox class='mt-4' name="accepted" value="1">
                <p class="text-14 text-grey-900 pl-2">Are you sure you want to take payment for {{ $help.dp(total) }}?</p>
            </InputCheckbox>

            <div class="modal-buttons pt-6">
                <ButtonSaving :disabled="saving" class="default button-black h-12 px-6">
					Take payment
				</ButtonSaving>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
    import Modal from '~/mixins/modal.js'

    export default {
        mixins: [Modal],

        data() {
            return {
                value: {
                    reason: null,
                    reason_other: '',
                    amount: 0,
                    include_vat: true
                }
            }
        },

        computed: {
            company() {
                return this.editingModel
            },

            total() {
                if (this.value.include_vat) {
                    return this.value.amount
                }

                return this.value.amount * 1.2
            },

            cards() {
                return this.editingModel.user.cards
            }
        }
    }
</script>